const validate = (formData) => {
    const errors = {};
    if(Object.keys(formData.selectedPermissions).length===0){
      errors.selectedPermissions = true;
    }
    return errors;
}

export default validate;